import { render, staticRenderFns } from "./QuickAddCalendarClient.vue?vue&type=template&id=adc878da&"
import script from "./QuickAddCalendarClient.vue?vue&type=script&lang=ts&"
export * from "./QuickAddCalendarClient.vue?vue&type=script&lang=ts&"
import style0 from "./QuickAddCalendarClient.vue?vue&type=style&index=0&id=adc878da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports